import { ResidenceSort, ResidencesQuery } from '../../../graphql/graphql';

export interface ResidencesListProps {
  residences: ResidencesQuery['residences'];
  hasError: boolean;
  sort: ResidenceSort;
}

export enum SquareFilterEnum {
  perSqr = 'perSqr',
  all = 'all'
}
